import * as React from "react";
import {ITranslatedComponent} from "../../../redux/reducers/generalReducer";
import {SpecDto, SpecDtoSpecCategory} from "../../../services/Client";
import Textfield from "../../../components/TextField";
import SelectField from "../../../components/SelectField";
import {Table, Modal} from "semantic-ui-react";
import Button from "../../../components/Button";
import {translate} from "react-i18next";

interface ISpecCreationDialogProps extends ITranslatedComponent {

    /** Callback when the user closes the dialog. */
    onClose?: (newSpec?: SpecDto) => any;
}

interface ISpecCreationDialogState {
    /** The code of the new spec. */
    specCode: string ;

     /** The selected category of the new spec. */
    selectedCategory: SpecDtoSpecCategory;
}

/**
 * The SpecCreationDialog collects all necessary information for
 * creating a new spec. The component doesn't create the spec itself
 * but passes a SpecDto to it's client through onClose() which is
 * expected to call the back end API to create the spec.
 */
class SpecCreationDialog extends React.Component<ISpecCreationDialogProps, ISpecCreationDialogState> {

    constructor(props: ISpecCreationDialogProps) {
        super(props);

        this.state = {
            specCode: "",
            selectedCategory: SpecDtoSpecCategory.ABGAS
        };
    }

    validateInput = (): boolean => {
        return this.state.specCode.length > 0 && this.state.selectedCategory ? true : false;
    }

    onClickCreate = (): void => {
        if (this.props.onClose) {
            const newSpec: SpecDto = {
                specCode: this.state.specCode,
                specCategory: this.state.selectedCategory,
                objectId: 0, // dummy objectId for creation
                versionId: 0, // dummy versionId for creation
            };
            this.props.onClose(newSpec);
        }
    }

    onClickCancel = (): void => {
        if (this.props.onClose) {
            this.props.onClose();
        }
    }

    renderSpecCodeControl = (): JSX.Element => (
        <Textfield
            placeholder={this.props.t("ENTER_SPEC_CODE")}
            onChange={(event: React.FormEvent<{}>, newValue: string) => {
                this.setState({specCode: newValue});
            }}
        />
    )

    renderCategoryControl = (): JSX.Element => (
        <SelectField
            dataSource={Object.keys(SpecDtoSpecCategory)}
            value={this.state.selectedCategory}
            clearable={false}
            searchable={false}
            onChange={(category: SpecDtoSpecCategory) => this.setState({selectedCategory: category})}
        />
    )

    renderContent = (): JSX.Element => (
        <>
            <Table definition={true}>
                <Table.Body>
                    <Table.Row>
                        <Table.Cell>{this.props.t("SPEC_CODE")}*</Table.Cell>
                        <Table.Cell>{this.renderSpecCodeControl()}</Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell>{this.props.t("SPEC_CATEGORY")}*</Table.Cell>
                        <Table.Cell>{this.renderCategoryControl()}</Table.Cell>
                    </Table.Row>
                </Table.Body>
        </Table>
        * {this.props.t("MANDATORY_FIELD")}
        </>
    )

    render() {
        return (
            <Modal open={true} style={{"marginTop": 0}}>
                <Modal.Header>{this.props.t("ADD_SPEC")}</Modal.Header>
                <Modal.Content>
                    {this.renderContent()}
                </Modal.Content>
                <Modal.Actions>
                    <Button
                        icon={"checkmark"}
                        disabled={!this.validateInput()}
                        onClick={this.onClickCreate}
                    />
                    <Button
                        icon={"ban"}
                        onClick={this.onClickCancel}
                    />
                </Modal.Actions>
            </Modal>
        );
    }
}

export default translate("SPECS")(SpecCreationDialog);



// WEBPACK FOOTER //
// ./src/views/AdminView/ConfigMaintenanceTab/SpecCreationDialog.tsx